import { getLocale } from '@libs/core';

const CLIENT_ID = process.env.NEXT_PUBLIC_SFCC_CLIENT_ID;
const SFCC_VERSION = process.env.NEXT_PUBLIC_SFCC_VERSION;
const SANDBOX =
    getLocale() === 'en-CA'
        ? process.env.SFCC_SANDBOX_CA
        : process.env.SFCC_SANDBOX_US;

if (!CLIENT_ID) {
    throw new Error(`
        ERROR: The environment variable "NEXT_PUBLIC_SFCC_CLIENT_ID" is not set in
        the .env file located at the root of the project.

        Client ID is used to authenticate against OCAPI. Check the Password Vault
        or Administration > Open Commerce API settings to obtain a Client ID.

        More info at: https://help.salesforce.com/s/articleView?id=cc.b2c_account_manager_add_api_client_id.htm
    `);
}

if (!SFCC_VERSION) {
    throw new Error(`
        ERROR: The environment variable "NEXT_PUBLIC_SFCC_VERSION" is
        not set in the .env file located at the root of the project.

        This variable is used to determine the version of OCAPI that the project is
        going to use. You can obtain the most recent version at
        https://developer.salesforce.com/docs/commerce/b2c-commerce/references/b2c-commerce-ocapi/get-started-with-ocapi.html
    `);
}

export { CLIENT_ID, SFCC_VERSION, SANDBOX };
